import { render, staticRenderFns } from "./trustship.vue?vue&type=template&id=afaa69bc&scoped=true"
import script from "./trustship.vue?vue&type=script&lang=js"
export * from "./trustship.vue?vue&type=script&lang=js"
import style0 from "./trustship.vue?vue&type=style&index=0&id=afaa69bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaa69bc",
  null
  
)

export default component.exports